export const CLUB_READY_CUSTOM_LIST_OPTION_GRAPHQL_ID = 'Y2x1YlJlYWR5TGlzdC41';
export const CLUB_READY_MULTI_LOCATION_SEND_STATS_CAP = 10;
